module.exports = __webpack_public_path__ + "img/5.b6a684a4.jpg";